import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-key-features',
  templateUrl: './offline-key-features.component.html',
  styleUrls: ['./offline-key-features.component.scss']
})
export class OfflineKeyFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
